/**
 * Copia texto para a área de transferência. Nunca rejeita: devolve `true` se
 * copiou e `false` se nenhum dos dois caminhos funcionou — quem chama decide o
 * aviso ao operador.
 *
 * Primeiro `navigator.clipboard` (exige contexto seguro e foco); se faltar ou
 * recusar, cai no `textarea` + `execCommand("copy")`.
 */

function copiaViaTextarea(texto) {
  try {
    const area = document.createElement("textarea");
    area.value = texto;
    area.setAttribute("readonly", "");
    area.style.position = "fixed";
    area.style.top = "-1000px";
    area.style.left = "-1000px";
    area.style.opacity = "0";
    document.body.appendChild(area);
    area.select();
    area.setSelectionRange(0, texto.length);
    const copiou = document.execCommand("copy");
    document.body.removeChild(area);
    return copiou;
  } catch (erro) {
    return false;
  }
}

export function copiarParaAreaDeTransferencia(texto) {
  if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
    // `writeText` pode LANÇAR de forma síncrona (política de permissões, contexto
    // inseguro) em vez de devolver uma promise rejeitada: o `.catch` abaixo não pega isso.
    // Sem o try/catch a função quebraria a promessa de "nunca rejeita" e a view ficaria
    // sem toast, nem de sucesso nem de erro.
    try {
      return navigator.clipboard
        .writeText(texto)
        .then(() => true)
        .catch(() => copiaViaTextarea(texto));
    } catch (erro) {
      return Promise.resolve(copiaViaTextarea(texto));
    }
  }

  return Promise.resolve(copiaViaTextarea(texto));
}
